import { render } from "./Users.vue?vue&type=template&id=7b0ed67f"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"
script.render = render

export default script